var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"template-box"},[_c('div',{staticClass:"Loading-box"},[_c('img',{attrs:{"src":require("../../assets/loading.gif"),"alt":"TOZO loading img"}}),(_vm.LoadingText)?_c('div',{staticClass:"Loading-text"},[_vm._v(_vm._s(_vm.$t('loading'))+"...")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }